export class Division {
    /** obsolete.  use code instead */
    millId: string;
    name: string;
    code: string;
    address1: string;
    state: string;
    postalCode: string;
    city: string;
    id: number;
    railServed: boolean;
}